<template>
  <div class="row trainingtable">
    <div class="col-12 m-0 p-0">
      <b-button v-b-toggle.filtro class="buttonColapse d-flex align-items-center float-right">
        <div class="
            textButtonColapse
            m-3
            d-flex
            align-items-center
            justify-content-between
          ">
          <p class="m-0 pr-2">Filtro</p>
          <img class="centerImg1 arrow" src="@/assets/images/icons/filter_list.svg" width="15px" />
        </div>
      </b-button>
    </div>
    <b-collapse id="filtro" class="col-12 mt-4 py-5 filter">
      <div class="row">
        <div class="col-md-9">
          <div class="col-md-9 col-sm-10 my-3">
            <h3>Busqueda:</h3>
            <input v-model="filter" @keydown="startTipyng()" @keyup="finishTipyng()" type="text"
              class="form-control my-3 input-vp2" placeholder="Búsqueda por nombre" />
          </div>
          <!--<div class="col-md-11">
            <h3>Punto de venta:</h3>
            <div class="d-flex flex-wrap">
              <div class="m-3">
                <input
                  v-model="filterSelected"
                  type="checkbox"
                  id="approved"
                  name="approved"
                  value="approved"
                />
                <label for="approved">
                  <span class="status mt-4" style="background-color: #edf9f0">
                    <img
                      class="centerImg1 mr-3"
                      src="@/assets/images/icons/check.svg"
                      width="20px"
                    />Aprobado
                  </span>
                </label>
              </div>
              <div class="m-3">
                <input
                  v-model="filterSelected"
                  type="checkbox"
                  id="rejected"
                  name="rejected"
                  value="rejected"
                />
                <label for="rejected">
                  <span class="status my-2" style="background-color: #feefef">
                    <img
                      class="centerImg1 mr-3"
                      src="@/assets/images/icons/deny-red.svg"
                      width="20px"
                    />Rechazado
                  </span>
                </label>
              </div>
              <div class="m-3">
                <input
                  v-model="filterSelected"
                  type="checkbox"
                  id="pending"
                  name="pending"
                  value="pending"
                />
                <label for="pending">
                  <span class="status" style="background-color: #fff4ec">
                    <img
                      class="centerImg1 mr-3"
                      src="@/assets/images/icons/orange-clock.svg"
                      width="20px"
                    />Pendiente
                  </span>
                </label>
              </div>
              <div class="m-3">
                <input
                  v-model="filterSelected"
                  type="checkbox"
                  id="cancelled"
                  name="cancelled"
                  value="cancelled"
                />
                <label for="cancelled">
                  <span class="status" style="background-color: #f5f5f5">
                    <img
                      class="centerImg1 mr-3"
                      src="@/assets/images/icons/close_gray.svg"
                      width="20px"
                    />Cancelado
                  </span>
                </label>
              </div>
              <div class="m-3">
                <input
                  v-model="filterSelected"
                  type="checkbox"
                  id="training"
                  name="training"
                  value="training"
                />
                <label for="training">
                  <span class="status" style="background-color: #feffc8">
                    <img
                      class="centerImg1 mr-3"
                      src="@/assets/images/icons/weight.svg"
                      width="20px"
                    />Entrenando
                  </span>
                </label>
              </div>
              <div class="m-3">
                <input
                  v-model="filterSelected"
                  type="checkbox"
                  id="ending"
                  name="ending"
                  value="ending"
                />
                <label for="ending">
                  <span class="status" style="background-color: #f7e7ff">
                    <img
                      class="centerImg1 mr-3"
                      src="@/assets/images/icons/timelapse.svg"
                      width="20px"
                    />Finalizando
                  </span>
                </label>
              </div>
            </div>
          </div>-->
        </div>
        <div class="col-md-3">
          <b-button pill class="text-center mb-4 mt-4" size="lg" variant="success" @click="loadRows()">
            Aplicar filtro
          </b-button>
          <br />
          <b-button pill class="text-center" size="lg" variant="outline-danger" style="border: none" @click="limpiar()">
            Limpiar filtro <span class="icon icon-bin"></span>
          </b-button>
        </div>
      </div>
    </b-collapse>
    <div v-if="loading" class="col-12">
      <div class="mt-5" v-if="loading" id="loader"></div>
    </div>
    <div v-else class="px-3 table-responsive table-views">
      <datatable :columns="datatable.columns" :data="datatable.rows" :per-page="datatable.perPage"
        :page="datatable.page" class="col-12 mt-2">
        <template slot-scope="{ row, columns }">
          <tr @click="editTraining(row.id)">
            <template>
              <datatable-cell v-for="(column, j) in columns" :key="j" :column="column" :row="row">
              </datatable-cell>
            </template>
          </tr>
        </template>
      </datatable>
      <div class="col-12 cont-pagination my-5 d-flex justify-content-center">
        <Pagination :data="trainingInfo" :limit="10" @pagination-change-page="loadRows"></Pagination>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Pagination from "laravel-vue-pagination";
import serverConfig from "../../services/config";

export default {
  name: "trainingextended",
  components: {
    Pagination,
  },
  data() {
    return {
      runtime: "",
      filter: "",
      filterSelected: [],
      serverPath: serverConfig.permisosURL,
      datatable: {
        total: 18,
        perPage: 20,
        columns: [],
        rows: [],
      },
      datatableInfoTraining: {
        columns: [],
        rows: [],
      },
      range: {
        start: "",
        end: "",
      },
      modelConfig: {
        type: "string",
        mask: "YYYY-MM-DD", // Uses 'iso' if missing
      },
      promotion: null,
      newCharge: { id: null, name: "" },
      charges: [{ value: { id: null, name: "" }, text: "Elige un Cargo" }],
      cancelStatus: "",
      nextStatus: "",
      employee: {},
      buttonAccept: "",
      buttonReject: "",
      notEdit: false,
      attrs: {},
      buttonEdit: true,
      date: "",
    };
  },
  beforeMount() {
    this.loadRows();
  },
  computed: {
    ...mapState("modPayRollNews", [
      "trainingInfo",
      "training",
      "loading",
      "loading2",
      "error",
      "message",
    ]),
  },
  methods: {
    ...mapActions("modPayRollNews", [
      "actGetTrainingInfo",
      "actGetTrainingInfoById",
      "actSaveTrainingInfo",
    ]),
    startTipyng() {
      clearTimeout(this.runTime);
    },
    finishTipyng() {
      this.runTime = setTimeout(() => {
        //this.loadRows();
        console.log("this.loadRows()");
      }, 1500);
    },
    limpiar() {
      // Estados
      document.getElementById("approved").checked = false;
      document.getElementById("rejected").checked = false;
      document.getElementById("pending").checked = false;
      document.getElementById("cancelled").checked = false;
      document.getElementById("training").checked = false;
      document.getElementById("ending").checked = false;

      this.filter = null;
      this.loadRows();
    },
    loadRows(page = 1) {
      let data2 = [];
      data2 = {
        page: page,
        filter: this.filter,
        status: this.filterSelected,
      };
      this.actGetTrainingInfo(data2).then(() => {
        this.datatable.columns = [
          {
            label: "Reemplazar",
            field: "name_employee",
            align: "left",
            headerClass: "theading",
          },
          {
            label: "Remplazo",
            field: "name_employee",
            align: "left",
            headerClass: "theading",
          },
          {
            label: "Cargo",
            field: "point_sale",
            align: "left",
            headerClass: "theading",
          },
          {
            label: "PDV. Origen",
            field: "point_sale",
            align: "left",
            headerClass: "theading",
          },
          {
            label: "PDV. Destino",
            field: "point_sale",
            align: "left",
            headerClass: "theading",
          },
          {
            label: "Desde",
            field: "fecha",
            align: "left",
            headerClass: "theading",
          },
          {
            label: "Hasta",
            field: "fecha",
            align: "left",
            headerClass: "theading",
          }
        ];
        this.datatable.rows = [];
        this.trainingInfo.data.forEach((x) => {
          let status = {};
          switch (x.status) {
            case "Pendiente":
              status = {
                color: "#FFF4EC",
                icon: "orange-clock.svg",
                text: x.status,
              };
              break;
            case "Entrenando":
              status = {
                color: "#FEFFC8",
                icon: "weight.svg",
                text: x.status,
              };
              break;
            case "Finalizando":
              status = {
                color: "#F7E7FF",
                icon: "timelapse.svg",
                text: x.status,
              };
              break;
            case "Rechazado":
              status = {
                color: "#FEEFEF",
                icon: "deny-red.svg",
                text: x.status,
              };
              break;
            case "Aprobado":
              status = {
                color: "#EDF9F0",
                icon: "check.svg",
                text: x.status,
              };
              break;
            case "Cancelado":
              status = {
                color: "#F5F5F5",
                icon: "close_gray.svg",
                text: x.status,
              };
              break;
          }
          this.datatable.rows.push({
            id: x.id,
            name_employee: x.name_employee,
            category_name: x.category_name,
            point_sale: x.point_sale,
            fecha: x.fecha,
            status: status,
          });
        });
      });
    },

    resetValues() {
      this.range = { start: "", end: "" };
      this.promotion = null;
      this.newCharge = { id: null, name: "" };
      this.datatableInfoTraining.rows = [];
      this.notEdit = false;
      this.buttonEdit = true;
    },
    editTraining(id) {
      this.resetValues();
      this.$root.$emit("bv::show::modal", "modal-training");
      this.actGetTrainingInfoById(id).then(() => {
        this.datatableInfoTraining.columns = [
          {
            label: "Nombre y apellidos",
            field: "name",
            align: "left",
            headerClass: "theading",
          },
          {
            label: this.training.employee.document,
            field: "cc",
            align: "left",
            headerClass: "theading",
          },
          {
            label: "Categoria",
            field: "category",
            align: "left",
            headerClass: "theading",
          },
          {
            label: "Punto de Venta",
            field: "point_sale",
            align: "left",
            headerClass: "theading",
          },
          {
            label: "Cargo asignado",
            field: "charge",
            align: "left",
            headerClass: "theading",
          },
        ];
        this.employee = this.training.employee;
        this.datatableInfoTraining.rows = [];
        this.datatableInfoTraining.rows.push({
          name: this.employee.name,
          cc: this.employee.cc,
          category: this.employee.category,
          point_sale: this.employee.point_sale,
          charge: this.employee.charge,
        });
        this.charges = [
          { value: { id: null, name: "" }, text: "Elige un Cargo" },
        ];
        this.training.charges.forEach((x) => {
          let chargesGroups = [];
          x.charges.forEach((y) => {
            chargesGroups.push({
              value: { id: y.id, name: y.name },
              text: y.name,
            });
          });
          this.charges.push({
            label: x.name_category,
            options: chargesGroups,
          });
        });
        if (this.training.data.status == "pending") {
          this.buttonAccept = "Confirmar entrenamiento";
          this.buttonReject = "Cancelar entrenamiento";
          this.nextStatus = "training";
          this.cancelStatus = "cancelled";
        } else {
          // Se establecen las fechas y atributos en el calendario

          let end = new Date(this.training.data.end_date);
          let endDay = end.getDate();
          end.setDate(endDay + 1);

          let start = new Date(this.training.data.start_date);
          let startDay = start.getDate();
          start.setDate(startDay + 1);

          this.date = start;

          this.attrs = [
            {
              highlight: {
                start: {
                  color: "teal",
                  fillMode: "solid",
                },
                base: {
                  color: "teal",
                  fillMode: "light",
                },
                end: {
                  color: "teal",
                  fillMode: "solid",
                },
              },
              dates: { start: start, end: end },
            },
            {
              key: "today",
              dot: "teal",
              dates: new Date(),
            },
          ];

          if (this.training.data.promotion !== null) {
            this.promotion =
              this.training.data.promotion == true ? "true" : "false";
          }
          this.range = { start: start, end: end };
          for (var i = 1; i < this.charges.length; i++) {
            this.charges[i].options.forEach((y) => {
              if (y.value.id == this.training.data.new_position_id) {
                this.newCharge = y.value;
              }
            });
          }
          this.notEdit = true;
          this.buttonAccept = "Aprobar entrenamiento";
          this.buttonReject = "Reprobar entrenamiento";
          this.nextStatus = "approved";
          this.cancelStatus = "rejected";

          if (
            this.training.data.status == "cancelled" ||
            this.training.data.status == "approved" ||
            this.training.data.status == "rejected"
          ) {
            this.buttonEdit = false;
          }
        }
      });
    },
    nextStep(x) {
      let data = {};
      if (x == "training") {
        data = {
          id: this.training.data.id,
          start_date: this.range.start,
          end_date: this.range.end,
          promotion: this.promotion == "true" ? true : false,
          new_position_id: this.newCharge.id,
          status: x,
        };
        this.actSaveTrainingInfo(data).then(() => {
          if (this.error.message) {
            this.$root.$emit("bv::hide::modal", "modal-confirm");
            this.$root.$emit("bv::hide::modal", "modal-training");
            this.$root.$emit("bv::show::modal", "modal-fail");
            this.loadRows();
            this.resetValues();
          } else {
            this.$root.$emit("bv::hide::modal", "modal-confirm");
            this.$root.$emit("bv::hide::modal", "modal-training");
            this.$root.$emit("bv::show::modal", "modal-success");
            this.loadRows();
            this.resetValues();
          }
        });
      } else {
        data = {
          id: this.training.data.id,
          status: x,
        };
        this.actSaveTrainingInfo(data).then(() => {
          if (this.error.message) {
            this.$root.$emit("bv::hide::modal", "modal-confirm");
            this.$root.$emit("bv::hide::modal", "modal-training");
            this.$root.$emit("bv::show::modal", "modal-fail");
            this.$root.$emit("bv::hide::modal", "modal-reject");

            this.loadRows();
            this.resetValues();
          } else {
            console.log("eeerror false");
            this.$root.$emit("bv::hide::modal", "modal-confirm");
            this.$root.$emit("bv::hide::modal", "modal-training");
            this.$root.$emit("bv::show::modal", "modal-success");
            this.$root.$emit("bv::hide::modal", "modal-reject");
            this.loadRows();
            this.resetValues();
          }
        });
      }
    },
  },
};
</script>

<style lang="scss">
.trainingtable {
  .filter {
    border: solid rgb(207, 207, 207) 1px;
    border-radius: 10px;
    background-image: url("../../assets/images/icons/vector-seacrh-filter.svg");
    background-repeat: no-repeat;
    background-position: right bottom;
    background-size: 20%;

    h3 {
      font-weight: 600;
      color: #1c6776;
    }
  }

  .input-vp2 {
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;
  }

  .custom-checkbox {
    margin: 15px 0;
  }

  .buttonColapse {
    background: rgba(38, 152, 135, 0.14);
    border: 2px solid #269887;
    color: #269887;
    font-size: 12px;
    border-radius: 100px;
  }

  select.custom-select {
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;
  }

  .status {
    padding: 5px 15px;
    border-radius: 20px;
  }

  .table-views {
    border-radius: 8px;
    padding: 0;
    margin: 30px 5px;

    .t-head {
      background-color: #f5f5f5;
      padding: 5px 15px;
      text-align: left;
    }

    input {
      padding: 10px 10px;
      font-size: 15px;
      height: 50px;
      border-radius: 10px;
    }

    thead tr {
      background-color: #eef2fa;
      border-radius: 10px;
      text-align: left;
    }

    .theading {
      padding: 15px 15px;
    }

    tbody tr {
      border-radius: 10px;
    }

    tbody tr td {
      padding: 15px 15px;
      cursor: pointer;
    }

    tbody tr:hover {
      background-color: #f5f5f5;
    }
  }
}

.modal-content .modal-training {
  font-family: Open Sans;

  select.custom-select {
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;
  }

  .charge {
    border: 1px dashed #dddddd;
    border-radius: 8px;
  }

  .modal-header {
    border: none;
  }

  .input-vp2,
  button {
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;
  }

  .btn-outline-success {
    border-radius: 20px;
    color: #269887;
    border-color: #269887;
  }

  .btn-outline-success:hover,
  .btn-success {
    color: white;
    background-color: #269887;
    border-color: #269887;
  }

  .btn-success:hover {
    background-color: #27a391;
  }

  .regular {
    background-color: white;
    border: none;
    color: #269887;
  }

  .delete {
    background-color: white;
    border: none;
    color: #da1414;
  }

  h3 {
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 30px;
    text-align: center;
  }

  #loader2 {
    margin: 20px auto;
    z-index: 1;
    width: 100px;
    height: 100px;
    border: 15px solid #f3f3f3;
    border-radius: 50%;
    border-top: 15px solid #8f8f8f;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  .table-views {
    height: fit-content;
    border-radius: 8px;
    padding: 0;

    .t-head {
      background-color: #f5f5f5;
      padding: 5px 15px;
      text-align: left;
      font-size: 15px;
    }

    thead tr {
      background-color: #eef2fa;
      border-radius: 10px;
      text-align: left !important;
    }

    .theading {
      padding: 15px 10px;
    }

    th.theading span {
      font-size: 15px;
    }

    tbody tr {
      border-radius: 10px;
      border-bottom: 1px solid #e9ecee;
    }

    tbody tr td {
      padding: 15px 10px;
      font-size: 14px;
    }

    .buttonColapse,
    .buttonColapse:hover,
    .buttonColapse:active {
      background-color: transparent;
      border: none;
      box-shadow: none;
    }
  }

  .formulario {
    h3 {
      font-size: 16px;
      color: #1c3a4e;
      font-weight: 600;
    }

    .vc-container {
      font-family: Poppins;
      box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
      border: none;

      .vc-grid-cell {
        margin: 5px;
      }
    }
  }
}
</style>